import { isPast, compareAsc, isValid } from 'date-fns';

export const LIMITS = {
  title: 55,
  description: 120,
  discountBannerName: 55,
  discountBannerDescription: 120,
};

export const validationErrors = (values = {}, services = []) => {
  let msg;
  const announcement = values.announcement || {};
  const normalizedServices = Array.isArray(services) ? services : [];
  const activeServices = normalizedServices.filter(service => {
    const serviceType = service?.serviceType;

    return (
      serviceType !== '' && serviceType !== null && serviceType !== undefined
    );
  });

  const fromDate = new Date(`${values.dateFrom} ${values.timeFrom}`);
  const toDate = new Date(`${values.dateTo} ${values.timeTo}`);

  if ((values.title_ru || '').length > LIMITS.title) {
    msg = `Kampanijos pavadinimas (RU) negali būti ilgesnis nei ${LIMITS.title} ženklai`;
  }

  if ((values.title_en || '').length > LIMITS.title) {
    msg = `Kampanijos pavadinimas (EN) negali būti ilgesnis nei ${LIMITS.title} ženklai`;
  }

  if ((values.title_lt || '').length > LIMITS.title) {
    msg = `Kampanijos pavadinimas (LT) negali būti ilgesnis nei ${LIMITS.title} ženklai`;
  }

  if ((values.description_ru || '').length > LIMITS.description) {
    msg = `Kampanijos pavadinimas (RU) negali būti ilgesnis nei ${LIMITS.description} ženklai`;
  }

  if ((values.description_en || '').length > LIMITS.description) {
    msg = `Kampanijos pavadinimas (EN) negali būti ilgesnis nei ${LIMITS.description} ženklai`;
  }

  if ((values.description_lt || '').length > LIMITS.description) {
    msg = `Kampanijos pavadinimas (LT) negali būti ilgesnis nei ${LIMITS.description} ženklai`;
  }

  if (!values.title_ru) {
    msg = 'Įveskite kampanijos pavadinimą (RU)';
  }

  if (!values.title_en) {
    msg = 'Įveskite kampanijos pavadinimą (EN)';
  }

  if (!values.title_lt) {
    msg = 'Įveskite kampanijos pavadinimą (LT)';
  }

  if (!values.description_ru) {
    msg = 'Įveskite kampanijos detalų pavadinimą (RU)';
  }

  if (!values.description_en) {
    msg = 'Įveskite kampanijos detalų pavadinimą (EN)';
  }

  if (!values.description_lt) {
    msg = 'Įveskite kampanijos detalų pavadinimą (LT)';
  }

  if (!activeServices.length) {
    msg = 'Pasirinkite bent vieną paslaugą';
  }

  if (
    normalizedServices.some(service => {
      const hasServiceType =
        service?.serviceType !== '' &&
        service?.serviceType !== null &&
        service?.serviceType !== undefined;
      const hasDiscount =
        service?.discount !== '' && service?.discount !== null;

      return hasServiceType !== hasDiscount;
    })
  ) {
    msg = 'Kiekvienai pasirinktai paslaugai nurodykite nuolaidos dydį';
  }

  if (
    activeServices.some(service => {
      const discount = Number(service.discount);

      return !Number.isInteger(discount) || discount < 1 || discount > 100;
    })
  ) {
    msg = 'Nuolaida turi būti sveikas skaičius nuo 1 iki 100';
  }

  if (Number(values.type) === 192) {
    if (!values.usage_limit && values.usage_limit !== 0) {
      msg = 'Nurodykite, kiek kartų nuolaida gali būti panaudota';
    }

    if (Number(values.usage_limit) < 1) {
      msg = 'Panaudojimų kiekis turi būti bent 1';
    }
  }

  if (values.createDiscountBanner) {
    if (!announcement.banner && !announcement.banner_id) {
      msg = 'Būtina įkelti banerio nuotrauką!';
    }

    if (
      !Array.isArray(values.bannerPlacements) ||
      !values.bannerPlacements.length
    ) {
      msg = 'Pasirinkite, kur bus rodomas baneris';
    }
  }

  if (isPast(toDate)) {
    msg = '"Laikotarpis iki" turi būti data ateityje';
  }

  if (!isValid(fromDate) || !isValid(toDate)) {
    msg = 'Blogai įvestas laikotarpis';
  }

  if (compareAsc(toDate, fromDate) !== 1) {
    msg = '"Laikotarpis nuo" turi būti vėliau nei "Laikotarpis iki"';
  }

  if (!values.code) {
    msg = 'Įveskite kampanijos pavadinimą';
  }

  return msg;
};
